// ============================================================
// Копирование в буфер + всплывашка «Скопировано!».
// Общий модуль для раздела «Карты» и инструментов (/tools).
// ============================================================

import { t } from '../i18n';

/** Ссылка без протокола — копируем так, как её вводили. */
export function linkForCopy(link: string): string {
    return link.replace(/^https?:\/\//i, '');
}

let toastTimer: ReturnType<typeof setTimeout> | null = null;

/** Короткое всплывающее сообщение снизу экрана. */
function showToast(message: string): void {
    let toast = document.getElementById('maps-toast');
    if (!toast) {
        toast = document.createElement('div');
        toast.id = 'maps-toast';
        toast.className = 'maps-toast';
        document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast?.classList.remove('is-visible'), 1500);
}

/** Копирует текст и показывает короткое «Скопировано!». */
export async function copyWithToast(text: string): Promise<void> {
    try {
        await navigator.clipboard.writeText(text);
    } catch {
        // Фолбэк для окружений без Clipboard API (http / старые браузеры)
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try {
            document.execCommand('copy');
        } catch {
            /* ignore */
        }
        ta.remove();
    }
    showToast(t('maps.copied'));
}

/**
 * Кнопка-ссылка карты: клик копирует её (без протокола).
 * showLink=false — подпись «Ссылка» (список карт), true — показываем саму ссылку (инструменты).
 * Клик не всплывает — чтобы не открывать редактор/не переключать строку.
 */
export function buildLinkCopyButton(link: string, className = 'map-card-link', showLink = false): HTMLButtonElement {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = className;
    btn.title = t('maps.copy_link');
    btn.textContent = showLink ? link : t('maps.link');
    btn.addEventListener('click', (e) => {
        e.stopPropagation();
        void copyWithToast(linkForCopy(link));
    });
    return btn;
}
